//1.导入VueRouter
import Vue from "vue";
import VueRouter from 'vue-router'
//2.使用路由
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}
//3.创建VueRouter的实例
const router = new VueRouter({
  //tips:不想要 #（锚点）就添加下面代码
  // mode:'history'
  //4.配置路由的path和组件
  routes: [
    // ==================== 公开页面 ====================
    {
      path: "/",
      name: 'home',
      component: () => import('../views/public/HomeView.vue'),
      mata: {
        title: '合木智构首页'
      }
    },
    {
      path: "/about",
      name: 'about',
      component: () => import('../views/public/AboutView.vue'),
      mata: {
        title: '关于合木智构'
      }
    },
    {
      path: "/login",
      name: 'login',
      component: () => import('../views/public/LoginView.vue')
    },
    {
      path: "/ShearWallCases",
      name: 'ShearWallCases',
      component: () => import('../views/public/Cases_ShearWall.vue')
    },
    {
      path: "/core",
      name: 'core',
      component: () => import('../views/public/Cases_FrameCoreTube.vue')
    },
    {
      path: "/IntelligentDesign",
      name: 'IntelligentDesign',
      component: () => import('../views/public/IntelligentDesign.vue')
    },
    {
      path: "/IntelligentDesignLabs",
      name: 'IntelligentDesignLabs',
      component: () => import('../views/public/IntelligentDesignLabs.vue')
    },

    // ==================== 产品服务平台（需登录） ====================
    {
      path: "/auto-explain",
      name: 'auto-explain',
      component: () => import('../views/platform/ai_labs/AutoExplain.vue'),
      mata: {
        title: '自动解译'
      }
    },
    {
      path: "/usage-prediction",
      name: 'usage-prediction',
      component: () => import('../views/platform/ai_labs/MatPrediction.vue'),
      mata: {
        title: '材料用量预测'
      }
    },
    {
      path: "/projects",
      component: () => import('../views/user/ProjectView.vue'),
      redirect: "/projects/housemind",
      children: [
        {
          name: 'shearwall',
          path: "shearwall",
          component: () => import('../views/platform/struct_shearwall/ShearWallProject.vue'),
        },
        {
          path: "beam",
          component: () => import('../views/platform/struct_beam_shearwall/BeamProject.vue')
        },
        {
          path: "core",
          component: () => import('../views/platform/struct_frame_coretube/CoreProject.vue')
        },
        {
          path: 'shearwall-cases',
          component: () => import('../views/platform/struct_shearwall/ShearWallCases.vue'),
        },
        {
          path: '/projects/beam-cases',
          component: () => import('../views/platform/struct_beam_shearwall/BeamCases.vue')
        },
        {
          path: '/projects/core-cases',
          component: () => import('../views/platform/struct_frame_coretube/CoreCases.vue')
        },
        {
          path: '/projects/ganio',
          component: () => import('../views/platform/ai_labs/AIstructureDataprocess.vue')
        },
        {
          path: '/projects/housemind',
          component: () => import('../views/platform/archi_housemind/HousemindProject.vue')
        },
        {
          path: "copilot",
          component: () => import('../views/user/CopilotChatView.vue')
        }
      ]
    },
    {
      path: "/shearwall-item",
      name: 'shearwall-item',
      component: () => import('../views/platform/struct_shearwall/ShearWallItem.vue')
    },
    {
      path: "/shearwall-item-biad",
      name: 'shearwall-item-biad',
      component: () => import('../views/platform/struct_shearwall/ShearWallItemBiad.vue')
    },
    {
      path: "/beam-item",
      name: 'beam-item',
      component: () => import('../views/platform/struct_beam_shearwall/BeamItem.vue')
    },
    {
      path: "/core-item",
      name: 'core-item',
      component: () => import('../views/platform/struct_frame_coretube/CoreItem.vue')
    },
    {
      path: "/shop",
      component: () => import('../views/user/ShopView.vue'),
      redirect: ('/shop/shearwall'),
      children: [
        {
          path: "shearwall",
          component: () => import('../views/platform/struct_shearwall/ShearWallProduct.vue')
        },
        {
          path: "beam",
          component: () => import('../views/platform/struct_beam_shearwall/BeamProduct.vue')
        },
        {
          path: "core",
          component: () => import('../views/platform/struct_frame_coretube/CoreProduct.vue')
        },
        {
          path: "order",
          component: () => import('../views/user/OrderView.vue')
        },
      ]
    },
    {
      path: "/item",
      component: () => import('../views/platform/struct_shearwall/ShearWallItem.vue'),
    },
    {
      path: "/setting",
      component: () => import('../views/user/SettingView.vue')
    },

    // ==================== 管理后台 ====================
    {
      path: "/admin",
      component: () => import('../views/admin/AdministratorsData.vue'),
      redirect:"/admin/data",
      children: [
        {
          path: "data",
          component: () => import('../views/admin/AdminData.vue'),
          name:'剪力墙模块数据分析'
        },
        {
          path: "dataFrame",
          component: () => import('../views/admin/AdminDataFrame.vue'),
          name:'框架模块数据分析'
        },
        {
          path: "trainingData",
          component: () => import('../views/admin/TraingData.vue'),
          name:'训练数据'
        },
        {
          name: 'projectList',
          path: "projectList",
          component: () => import('../views/admin/AdminProjectListView.vue'),
        },
        {
          path: "user",
          component: () => import('../views/admin/AdminUser.vue'),
          name:'用户列表'
        },
        {
          path: "allProjectList",
          component: () => import('../views/admin/ProjectList.vue'),
          name:'剪力墙项目'
        },
        {
          path: "allProjectListFrame",
          component: () => import('../views/admin/FrameProjectList.vue'),
          name:'框架项目'
        },
        {
          path: "allProjectListHousemind",
          component: () => import('../views/admin/AdminDataHousemind.vue'),
          name:'Housemind项目'
        },
        {
          path: "log",
          component: () => import('../views/admin/AdminLog.vue'),
          name:'操作日志'
        },
        {
          path: "update",
          component: () => import('../views/admin/AdminUpdate.vue'),
          name:'版本更新'
        },
        {
          path: "production",
          component: () => import('../views/admin/AdminProducts.vue'),
          name:'管理商品信息'
        },
        {
          path: "message",
          component: () => import('../views/admin/AdminMessage.vue'),
          name:'群发通知'
        },
        {
          path: "historyNews",
          component: () => import('../views/admin/AdminHistoryNews.vue'),
          name:'历史消息'
        },
        {
          path: "version",
          component: () => import('../views/admin/AdminVersion.vue'),
          name:'版本管理'
        },
        {
          path: "addVersion",
          component: () => import('../views/admin/AdminAddVersion.vue'),
          name:'新增版本'
        },
        {
          path: "addNews",
          component: () => import('../views/admin/AdminAddNews.vue'),
          name:'新增资讯'
        },
        {
          path: "allNews",
          component: () => import('../views/admin/AdminAllNews.vue'),
          name:'查看历史资讯'
        },
      ]
    },

  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) { //拦截后设置标题
    document.title = to.meta.title
  }
  next()
})
//5.导入路由实例
export default router
